import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { imageUrlCheck } from "../../utils/utils";
import { getPodcastModal } from "../../Redux/PodcastModal/podcastModalSlice";
import { getSelectedChannel } from "../../Redux/SelectedChannel/selectedChannelSlice";
import { getSelectedSchedule } from "../../Redux/SelectedScheduleChannel/selectedScheduleChannelSlice";
import Translate, { useTranslateText } from "../Multilanguage/Translate";
import Util from "./util";
import { setAiInfo } from "../../Redux/AiType/AiTypeSlice";
import { ReactComponent as Closeicon } from "../../assets/Icons/cross.svg";
import RemoveFromContinueWatchModal from "../Modals/RemoveFromContinueWatchModal";
import ReactDOM from "react-dom";

const YowCard = ({ data, metaData, imageUrl ,type,thumbnailOrientation, playlist = true, showId, categoryName, tabIndex, role, ariaLabel, isChallenge ,onRemove ,displayedData }) => {
  const {
    showHandleClick,
    replaceImage,
    addToWatchlist,
    removeFromWatchlist,
    subscriptionCheck,
  } = Util();
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const user = useSelector((state) => state?.user?.value);
  const userSubscriptionData = useSelector(
    (state) => state?.userSubscription?.value
  );
  const [watchlistStatus, setWatchlistStatus] = useState();
  const [imagURL, setImageURL] = useState(thumbnailOrientation === "PORTRAIT" ? require("../../assets/Images/loading-portrait.gif") : require("../../assets/Images/loading-landscape.gif"))
  const [isImageLoad, setIsImageLoad] = useState(false)
  const [isRemoveModal, setIsRemoveModal] = useState(false);
  const [isRemoving, setIsRemoving] = useState(false);
  const [continueWatchingList, setContinueWatchingList] = useState([]);
  const [hovered, setHovered] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const dispatch = useDispatch();
  const translateText = useTranslateText();
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };
  const pubid = projectInfo?.projectConfig?.pubid;
  const ai_type = data?.ai_type ;
  useEffect(() => {
    if (data?.watchlist_flag === 1) {
      setWatchlistStatus("added");
    } else {
      setWatchlistStatus("removed");
    }
  }, [data]);

  useEffect(() => {
    setIsImageLoad(true)
    let image;
    if (
      imageUrlCheck(
        thumbnailOrientation === "PORTRAIT"
          ? data?.logo || data?.thumbnail || data?.banner_portrait
          : data?.logo_thumb || data?.thumbnail_350_200
      )
    ) {
      image =
        thumbnailOrientation === "PORTRAIT"
          ? data?.logo || data?.thumbnail || data?.banner_portrait
          : data?.logo_thumb || data?.thumbnail_350_200;
    } else {
       if(data?.type === "SMART_HOME" || data?.type === "GENRE")
        {
          image = data?.banner ? data?.banner : (thumbnailOrientation==='PORTRAIT'? projectInfo?.projectConfig?.config?.PLACEHOLDER_IMAGE_PORTRAIT : projectInfo?.projectConfig?.config?.PLACEHOLDER_IMAGE) 
        }
      else
      image =
      process.env.REACT_APP_IMAGE_URL +
        (thumbnailOrientation === "PORTRAIT"
          ? data?.logo || data?.thumbnail || data?.banner_portrait
          : data?.logo_thumb || data?.thumbnail_350_200);
    }

    setImageURL(image);
  }, [data, thumbnailOrientation]);

  useEffect(() => {
      
    if (data?.type === "CONTINUE_WATCHING"  ) {
      setContinueWatchingList(displayedData);
    }
  }, [data]);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleCardKeyDown = (e, action) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      action();
    }
  };

  const mainCardKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      dispatch(setAiInfo(ai_type ?? null));
      showHandleClick(
        data,
        type,
        projectInfo,
        thumbnailOrientation,
        getPodcastModal,
        getSelectedChannel,
        getSelectedSchedule,
        ai_type,
        showId,
        categoryName
      );
    }
  };

  const handleCloseRemoveModal = () => {
    setIsRemoveModal(false);
    setHovered(false);
  };
  return (
    <div className={`yowCardContainer showContents  ${data?.type === "SMART_HOME" ? 'genre-card' : ''}`}
      title={data?.show_name || data?.video_title || data?.categoryname}
      tabIndex={typeof tabIndex !== 'undefined' ? tabIndex : 0}
      role={role || "group"}
      aria-label={ariaLabel || data?.show_name || data?.video_title || data?.categoryname}
      onKeyDown={mainCardKeyDown}
      onClick={() => {
        dispatch(setAiInfo(ai_type ?? null));
        showHandleClick(
          data,
          type,
          projectInfo,
          thumbnailOrientation,
          getPodcastModal,
          getSelectedChannel,
          getSelectedSchedule,
          ai_type,
          showId,
          categoryName
        );
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
       {isRemoveModal &&
        ReactDOM.createPortal(
          <RemoveFromContinueWatchModal
            setIsRemoving={setIsRemoveModal}
            appInfo={appInfo}
            data={data}
            continueWatchingList={continueWatchingList}
            onRemove={onRemove}
            onCancel={handleCloseRemoveModal} 
          />,
          document.body 
        )
    }
      {/* <ToastContainer /> */}     
      {
        data?.type === "CONTINUE_WATCHING" && hovered && (
          <div
            className="close-icon"
            tabIndex={0}
            role="button"
            aria-label="Close"
            onClick={(e) => { e.stopPropagation(); setIsRemoveModal(true); }}
            style={{ cursor: isRemoving ? "not-allowed" : "pointer", opacity: isRemoving ? 0.5 : 1 }}
            title={translateText('remove_from_continue_watching')}
          >
            <Closeicon />
          </div>
        )
      }
      {
        data?.type !== "SMART_HOME" &&
      <div className="premiumStatus">
        { data?.is_free_video === true ? (
          <div className="free">
            <img
              src={require("../../assets/Images/free_icon.png")}
              alt="FreeIcon"
            />
          </div>
        )
         : data?.is_locked === true ?(
          <div className="lock">
            {pubid === 50158 ? (
              <img
                src={require("../../assets/Images/DocPlus_Plus.png")}
                className="docplus"
                alt="LockIcon"
              />
            ) : (
              <img
                src={require("../../assets/Images/lock.png")}
                alt="LockIcon"
              />
            )}
          </div>
        )
        :null
        }
      </div>
      }    

      <div className="imageContainer">
        {/* {imageUrlCheck(thumbnailOrientation==='PORTRAIT'?(data?.logo || data?.thumbnail):(data?.logo_thumb || data?.thumbnail_350_200)) ===false ? (
          <img
            src={thumbnailOrientation==='PORTRAIT'?`${process.env.REACT_APP_IMAGE_URL}${
              (data?.logo || data?.thumbnail)
            }`:`${process.env.REACT_APP_IMAGE_URL}${
              (data?.logo_thumb || data?.thumbnail_350_200)
            }`}
            alt="ShowImage"
          />
        ) : (
          <img src={thumbnailOrientation==='PORTRAIT'?
          `${data?.logo || data?.thumbnail}`
          :
          `${data?.logo_thumb || data?.thumbnail_350_200}`
        } alt="ShowImage" />
          
        )} */}
          <img
              className={
                `${!isImageLoad ? (thumbnailOrientation === "PORTRAIT" ? "portrait" : "landscape") : "showImage"}${data?.challenge_completed && isChallenge ? " blurred-image" : ""}`
              }
              src={
                imagURL
              }
              key={data?.show_id}
              // onError={(e)=>replaceImage(e)}
              // onLoad={(e)=>afterImageLoad(e)} 
              onError={(e) => replaceImage(e, thumbnailOrientation, projectInfo)}
              // onLoad={(e) =>
              //   afterImageLoad(
              //     e,
              //     thumbnailOrientation,
              //     data,
              //     setImageURL,
              //     setIsImageLoad,
              //     imageUrlCheck
              //   )
              // }
              alt="ShowImage"
                style={pubid === 50158 && data?.type != 'FASTCHANNEL'? { borderRadius: "8px" } : {}}
            />
        {
          (data?.type === "CONTINUE_WATCHING" || (data?.watched_percentage > 0 && data?.watched_percentage < 100)) &&
          <div className="continueWatchingBar">
            <div className="line" style={{ width: data?.watched_percentage <= 1 ? 1 + "%" : data?.watched_percentage + "%" }}></div>
          </div>
        }

        {data?.challenge_completed && isChallenge && (
          <div className="completionIndicator" title={translateText('already_watched')}>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 13L9 17L20 8" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        )}
        {
          data?.type !== "SMART_HOME" &&
        <div className="extraActions">
          <div
            className="showCardOverlay"
            onClick={(e) => {
                 e.stopPropagation();
                 dispatch(setAiInfo(ai_type ?? null));
                  showHandleClick(
                    data,
                    type,
                    projectInfo,
                    thumbnailOrientation,
                    getPodcastModal,
                    getSelectedChannel,
                    getSelectedSchedule,
                    ai_type,
                    showId,
                    categoryName
                  );
                }}
            tabIndex={-1}
            role="presentation"
            aria-hidden="true"
          ></div>
          <div className="hoverMeta">
            <div className="title">{data?.show_name || data?.video_title}</div>
            {metaData && data?.duration_text && <div className="duration">{data?.duration_text}</div>}
          </div>
          <div className="actionsRow">
          <div className="playIconContainer"
            tabIndex={0}
            role="button"
            aria-label={`Play ${data?.show_name || data?.video_title}`}
             onClick={(e) => {
                   e.stopPropagation();
                   dispatch(setAiInfo(ai_type ?? null));
                    showHandleClick(
                      data,
                      type,
                      projectInfo,
                      thumbnailOrientation,
                      getPodcastModal,
                      getSelectedChannel,
                      getSelectedSchedule,
                      ai_type,
                      showId,
                      categoryName
                    );
                  }}
            onKeyDown={e => { e.stopPropagation(); handleCardKeyDown(e, () => {
              dispatch(setAiInfo(ai_type ?? null));
              showHandleClick(
                data,
                type,
                projectInfo,
                thumbnailOrientation,
                getPodcastModal,
                getSelectedChannel,
                getSelectedSchedule,
                ai_type,
                showId,
                categoryName
              );
            })}}
          >
            <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
          {metaData && data?.show_id && playlist && data?.type !== "SMART_HOME" &&(
            <>
              {watchlistStatus === "added" ? (
                <div
                className="addToList"
                  tabIndex={0}
                  role="button"
                  aria-label={`Remove ${data?.show_name || data?.video_title} from my list`}
                  onClick={(e) => {
                    e.stopPropagation();
                    removeFromWatchlist(
                      data?.show_id,
                      appInfo,
                        (status) => {
                          setWatchlistStatus(status);
                          if (onRemove) {
                            onRemove(data?.video_id || data?.show_id);
                          }
                        }
                    );
                  }}
                  onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      e.stopPropagation();
                      removeFromWatchlist(
                        data?.show_id,
                        appInfo,
                        (status) => {
                          setWatchlistStatus(status);
                          if (onRemove) {
                            onRemove(data?.video_id || data?.show_id);
                          }
                        }
                      );
                    }
                  }}
                >
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true" focusable="false">
                    <path d="M5 12h14" />
                  </svg>
                </div>
              ) : (
                <div
                className="addToList"
                  tabIndex={0}
                  role="button"
                  aria-label={`Add ${data?.show_name || data?.video_title} to my list`}
                  onClick={(e) => {
                    e.stopPropagation();
                    addToWatchlist(
                      user,
                      data?.show_id,
                      appInfo,
                      setWatchlistStatus
                    );
                  }}
                  onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      e.stopPropagation();
                      addToWatchlist(
                        user,
                        data?.show_id,
                        appInfo,
                        setWatchlistStatus
                      );
                    }
                  }}
                >
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true" focusable="false">
                    <path d="M12 5v14" />
                    <path d="M5 12h14" />
                  </svg>
                </div>
              )}
            </>
          )}
          </div>
        </div>
        }       
      </div>

    </div>
  );
};

export default YowCard;
